import * as Sentry from '@sentry/react';

export function initMonitoring() {
  if (!process.env.REACT_APP_SENTRY_DSN) return;

  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: process.env.NODE_ENV === 'production' ? 0.1 : 0,
    environment: process.env.NODE_ENV,
    beforeSend(event, hint) {
      const error = hint?.originalException;
      if (error?.message && /token|access_token|bearer/i.test(error.message)) {
        return null;
      }
      return event;
    },
  });
}

export function logError(error, context = {}) {
  if (process.env.NODE_ENV !== 'production') {
    console.error('Erro capturado:', error, context);
  }
  if (process.env.REACT_APP_SENTRY_DSN) {
    Sentry.captureException(error, { extra: context });
  }
}

export function logEvent(name, data = {}) {
  if (process.env.NODE_ENV !== 'production') {
    console.log('Evento:', name, data);
  }
  if (process.env.REACT_APP_SENTRY_DSN) {
    Sentry.captureMessage(name, { level: 'info', extra: data });
  }
}

export default { initMonitoring, logError, logEvent };
